import { Container } from "../../primitives/container";
import React from "react";
import { Skeleton } from "../skeleton";
import { Grid } from "../../primitives/grid";

export const GridSkeleton: React.FC = () => {
    return (
        <Container className="p-6">
            <div className="mb-6">
                <Skeleton className="mb-1 h-3 w-32" />
                <Skeleton className="mb-2 h-7 w-24" />
                <Skeleton className="h-4 w-96" />
            </div>
            <div className="mb-6 flex items-center gap-3">
                <Skeleton className="h-9 w-64" />
                <Skeleton className="h-9 w-48" />
            </div>
            <Grid cols={3} gap="md" className="w-full items-stretch">
                {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i} className="border-border overflow-hidden rounded-2xl border">
                        <Skeleton className="h-52 w-full rounded-none" />
                        <div className="p-4">
                            <Skeleton className="mb-2 h-5 w-3/4" />
                            <Skeleton className="mb-1 h-3 w-full" />
                            <Skeleton className="mb-4 h-3 w-2/3" />
                            <div className="flex gap-1.5">
                                <Skeleton className="h-5 w-16 rounded-full" />
                                <Skeleton className="h-5 w-16 rounded-full" />
                            </div>
                        </div>
                        <div className="border-border flex items-center justify-between border-t px-4 py-3">
                            <Skeleton className="h-3 w-20" />
                            <Skeleton className="h-7 w-7 rounded-md" />
                        </div>
                    </div>
                ))}
            </Grid>
        </Container>
    );
};
